/**
 * YLI GA4 Search Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track site search usage, results, and clicks
 * GA4 Events: site_search_submit, search_result_click, search_no_results
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // Track which searches have been logged (prevent duplicates)
  var trackedSearches = new Set();

  // GA4 Event: site_search_submit
  // Track when users submit a search query
  function trackSearchSubmit() {
    // Listen for search form submissions
    document.addEventListener('submit', function(e) {
      var searchForm = e.target.closest('.search-form, form[action*="/search"]');
      if (!searchForm) return;

      var searchInput = searchForm.querySelector('input[name="q"]');
      if (!searchInput) return;

      var searchQuery = searchInput.value.trim();
      if (!searchQuery) return; // Don't track empty searches

      // Get results count from page (if on search results page)
      var resultsCount = 0;
      var resultsContainer = document.querySelector('#SearchLoop');
      if (resultsContainer) {
        // Count product grid items (excluding "no results" message)
        var productItems = resultsContainer.querySelectorAll('[data-product-id], .product-grid-item');
        var articleItems = resultsContainer.querySelectorAll('.search-results-item');
        resultsCount = productItems.length + articleItems.length;
      }

      // Determine search source
      var searchSource = 'header';
      if (searchForm.closest('[data-section-type="search"]')) {
        searchSource = 'search_page';
      } else if (searchForm.closest('.header-search-popdown, .search-popup')) {
        searchSource = 'header_dropdown';
      }

      // Create unique key for this search
      var searchKey = searchQuery.toLowerCase();

      // Only fire once per search query per session
      if (!trackedSearches.has(searchKey)) {
        trackedSearches.add(searchKey);

        if (typeof gtag === 'function') {
          gtag('event', 'site_search_submit', {
            'search_query': searchQuery,
            'results_count': resultsCount,
            'search_source': searchSource
          });
        }
      }
    });
  }

  // GA4 Event: search_no_results
  // Track when search returns zero results
  function trackNoResults() {
    // Check if we're on search results page
    if (!window.location.pathname.includes('/search')) return;

    // Look for "no results" message
    var noResultsElement = document.querySelector('.no-results, .search-results--empty');
    if (!noResultsElement) return;

    // Get search query from URL
    var urlParams = new URLSearchParams(window.location.search);
    var searchQuery = urlParams.get('q') || '';

    if (searchQuery && typeof gtag === 'function') {
      gtag('event', 'search_no_results', {
        'search_query': searchQuery,
        'page_url': window.location.pathname + window.location.search
      });
    }
  }

  // GA4 Event: search_result_click
  // Track when users click on search results
  function trackResultClick() {
    // Only track on search results page
    if (!window.location.pathname.includes('/search')) return;

    document.addEventListener('click', function(e) {
      // Check if click is on a search result link
      var resultLink = e.target.closest('#SearchLoop a, .search-results-item a, .search-product-item a');
      if (!resultLink) return;

      // Get search query from URL
      var urlParams = new URLSearchParams(window.location.search);
      var searchQuery = urlParams.get('q') || '';

      // Get result position
      var resultPosition = 0;
      var resultContainer = resultLink.closest('[data-product-id], .search-results-item, .product-grid-item');
      if (resultContainer) {
        var allResults = document.querySelectorAll('#SearchLoop [data-product-id], #SearchLoop .search-results-item, #SearchLoop .product-grid-item');
        resultPosition = Array.from(allResults).indexOf(resultContainer) + 1;
      }

      // Get result type (product vs article/page)
      var resultType = 'unknown';
      if (resultLink.href.includes('/products/')) {
        resultType = 'product';
      } else if (resultLink.href.includes('/blogs/') || resultLink.href.includes('/articles/')) {
        resultType = 'article';
      } else if (resultLink.href.includes('/pages/')) {
        resultType = 'page';
      } else if (resultLink.href.includes('/collections/')) {
        resultType = 'collection';
      }

      // Get result title
      var resultTitle = resultLink.textContent.trim();
      var titleElement = resultLink.querySelector('[data-product-title], .product-title, h3, h4');
      if (titleElement) {
        resultTitle = titleElement.textContent.trim();
      }

      if (typeof gtag === 'function') {
        gtag('event', 'search_result_click', {
          'search_query': searchQuery,
          'result_position': resultPosition,
          'result_type': resultType,
          'result_title': resultTitle,
          'result_url': resultLink.href
        });
      }
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackSearchSubmit();
      trackNoResults();
      trackResultClick();
    });
  } else {
    trackSearchSubmit();
    trackNoResults();
    trackResultClick();
  }

})();
